<template>
  <div class="pb-100">
    <div class="container">
      <div class="section-title">
        <span class="top-title">TESTIMONIALS</span>
        <h2 title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" >We help to achieve customers business goals</h2>
      </div>

      <div class="border-style pb-75">
        <swiper
          :spaceBetween="25"
          :slidesPerView="1"
          :preventClicks="true"
          :loop="true"
          :autoplay="{
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }"
          :navigation="{
            nextEl: '.next',
            prevEl: '.prev',
          }"
          :modules="modules"
          class="testimonial-slide"
        >
          <swiper-slide
            v-for="testimonial in testimonials"
            :key="testimonial.id"
          >
            <div class="testimonial-wrapper">
              <div class="row align-items-center">
                <div class="col-lg-3">
                  <div class="testimonial-info">
                    <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
                    :src="testimonial.image" alt="testimonials" />
                    <h3>{{ testimonial.name }}</h3>
                    <span class="degeneration">
                      {{ testimonial.designation }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-9">
                  <div class="for-before-after">
                    <div class="testimonials-single-item-two">
                      <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
                        src="../../assets/images/quotation-mark.png"
                        alt="quotation-mark"
                      />
                      <p>
                        {{ testimonial.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-controller testimonials-controller">
            <div class="controller-icon prev">
              <i class="ri-arrow-left-line"></i>
            </div>
            <div class="controller-icon next">
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

export default defineComponent({
  name: "TestimonialsContent",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          image: require("../../assets/logos/clients/c2.jpg"),
          name: "Ramraj Cotton",
          designation: "Marketing Head, Ramraj Cotton",
          description:
            "Working with MyCelebrity was seamless and effective. Their celebrity-led campaigns gave us massive regional reach and made our festive promotions a huge success.",
        },
        {
          id: 2,
          image: require("../../assets/logos/clients/c1.jpg"),
          name: "Jos Alukkas",
          designation: "Brand Manager, Jos Alukkas",
          description:
            "They brought in the perfect mix of glamour and strategy. Our product launch was not just successful — it was unforgettable. We’d trust them again for any high-visibility campaign.",
        },
        {
          id: 3,
          image: require("../../assets/logos/clients/c8.jpg"),
          name: "Casagrande India",
          designation: "Director, Casagrande India",
          description:
            "Their ability to manage events, PR, and influencer presence at scale helped us create strong brand recall within the construction and machinery industry. Extremely reliable team.",
        },
        {
          id: 4,
          image: require("../../assets/logos/clients/c16.jpg"),
          name: "Sunpure Oil",
          designation: "Marketing Team, Sunpure",
          description:
            "From influencer selection to full campaign execution, MyCelebrity understood our target market and delivered authentic content that connected with households across South India.",
        },
        {
          id: 5,
          image: require("../../assets/logos/clients/c4.jpg"),
          name: "Man Matters",
          designation: "Digital Head, Man Matters",
          description:
            "We wanted a content-first approach with real engagement — and they nailed it. Their influencer strategy helped us reach younger male audiences more organically.",
        },
        {
          id: 6,
          image: require("../../assets/logos/clients/littlejoys.jpg"),
          name: "Little Joys",
          designation: "Growth Manager, Little Joys",
          description:
            "We needed relatable mom influencers and quality content at scale. MyCelebrity delivered both with precision and care, helping us increase trust among young parents.",
        },
      ],
    };
  },
  setup() {
    return {
      Autoplay,
      modules: [Navigation, Autoplay],
    };
  },
});
</script>

<style lang="scss" scoped>
.testimonial-info {
  max-width: 1000px;
  text-align: center;
  margin: auto;

  img {
    border: 1px solid var(--headingColor);
    width: 180px;
    height: 60px;
    margin-bottom: 15px;
    object-fit: cover;
    /* Removed border-radius to disable round shape */
  }

  h3 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
  }

  span {
    font-size: 14px;
  }
}

.testimonials-single-item-two {
  max-width: 648px;
  margin-left: auto;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -124px;
    width: 1px;
    height: 100%;
    background-color: #e3e3e3;
  }

  img {
    margin-bottom: 25px;
  }

  p {
    font-weight: 500;
    font-size: 18px;
    font-style: italic;
    line-height: 30px;
    padding-bottom: 60px;
  }
}

.for-before-after {
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    width: 7px;
    height: 7px;
    background-color: #e3e3e3;
    border-radius: 50px;
    left: -3px;
  }

  &::after {
    top: auto;
    bottom: 0;
  }
}

.testimonial-wrapper {
  max-width: 1038px;
  margin: auto;
}

/* Responsive styles */
@media only screen and (max-width: 767px) {
  .testimonial-info {
    margin-bottom: 30px;
  }

  .testimonials-single-item-two::before,
  .for-before-after::before,
  .for-before-after::after {
    display: none;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .testimonial-info {
    margin-bottom: 30px;
  }

  .testimonials-single-item-two {
    min-width: 100%;

    &::before {
      display: none;
    }
  }

  .for-before-after::before,
  .for-before-after::after {
    display: none;
  }
}
</style>
